import React from "react";
import Pagination from "../components/common/pagination";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import SEO from "../components/seo";
var AllArticleList = function AllArticleList(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext;
    var author = pageContext.author, pageNumber = pageContext.pageNumber, pageCount = pageContext.pageCount, category = pageContext.category, authorName = pageContext.authorName;
    var pageTitle = category ? category : authorName ? authorName : "Alle Artikel";
    var basePath = category ? "kategorien/" + category.toLowerCase() + "/artikel" : author ? "autoren/" + author + "/artikel" : "alle-artikel";
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: pageTitle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, data.allDatoCmsArticle.edges.map(function (edge, index) {
        var _article$image;
        var article = edge.node;
        return /*#__PURE__*/ React.createElement(ArticleListItem, {
            key: article.id,
            articleId: article.id,
            authors: article.authors,
            excerpt: article.excerpt,
            to: "/" + article.slug + "/",
            title: article.title,
            image: (_article$image = article.image) === null || _article$image === void 0 ? void 0 : _article$image.fluid,
            smallTitle: article.smallTitle,
            index: index,
            authorLinks: false,
            visibility: article.visibility
        });
    }))), /*#__PURE__*/ React.createElement(Pagination, {
        currentPage: pageNumber,
        pageCount: pageCount,
        basePath: basePath
    }));
};
var query = "2971698216";
export default AllArticleList;
